import { lazy } from 'react';
import { RouteInterface } from '../types/Route';
import {
  HOMEPAGE,
  HEATMAP,
  GUIDES,
  BOOKINGS,
  TRACK,
  INBOX,
  LISTPROPERTY,
  SEARCH,
  DETAILSELL,
  DETAILBUY,
  PROPERTYSTEP,
  FINISH,
  MODAL,
  MODALBOOST,
  MODALLAST,
  PROFILE,
  ABOUTME,
  GOVERNMENTID,
  NATIONALIDTYPE,
  SINGPASS,
  PASSPORT,
  ADDDONE,
  CHOOSEIDTYPE,
  LISTING,
  REQUEST,
  PLANS,
  PROMOTE,
  PENALTY,
  TITLEDEEDS,
  PROOFOFFUNDS,
  APPROVALINPRINCIPLE,
  SELLINGAPROPERTY,
  BUYINGAPROPERTY,
  PASSWORD,
  TWOFA,
  INVITEFRIENDS,
  VIAMAIL,
  VIANUMBER,
  KUCING,
  LEGAL,
  AVAILABLE,
  AVAILAIBILITY,
  DOWNLOAD,
  PRIVACY,
  TERMS,
  PRICEMAP,
  SEARCHBAR,
} from './ConstantRoute';

/**
 * Lazy loading components
 */
const Home = lazy(() => import('./../Containers/Home'));
const HeatMap = lazy(() => import('../Containers/Heatmap/Heatmap'));
const Pricemap = lazy(() => import('../Containers/Heatmap/Heatmap'));
const SearchBar = lazy(() => import('../Containers/Heatmap/Main/ComponentMap/SearchBarWebflow'));
const Guide = lazy(() => import('./../Containers/Guides'));
const Bookings = lazy(() => import('../Containers/Bookings/Bookings'));
const Track = lazy(() => import('../Containers/Track/Track'));
const Inbox = lazy(() => import('../Containers/Inbox/Inbox'));
const ListProperty = lazy(() => import('../Containers/ListProperty/ListProperty'));
const PropertyStep = lazy(() => import('../Containers/ListPropertyStep2/PropertyStep'));
const NotFound = lazy(() => import('./../Containers/NotFound'));
const Search = lazy(() => import('./../Containers/Search'));
const DetailSell = lazy(() => import('../Containers/GalerySearch/MainGalery/DetailSell'));
const DetailBuy = lazy(() => import('../Containers/GalerySearch/MainGalery/DetailBuy'));
const Finish = lazy(() => import('./../Containers/ListProperty/Finish'));
const Modal = lazy(() => import('./../Containers/ListProperty/Modal/ModalAbout/ModalAbout'));
const Modalb = lazy(() => import('./../Containers/ListProperty/Modal/ModalBoost/ModalBoost'));
const ModalLast = lazy(() => import('./../Containers/ListProperty/Modal/ModalLast/ModalLast'));
const Profile = lazy(() => import('./../Containers/Profile'));
const AboutMe = lazy(() => import('./../Containers/Profile/Account/AboutMe'));
const GovernmentID = lazy(() => import('./../Containers/Profile/Account/GovernmentID'));
const NationalID = lazy(() => import('./../Containers/Profile/Account/GovernmentID/NationalId'));
const Singpass = lazy(() => import('./../Containers/Profile/Account/GovernmentID/Singpass'));
const Passport = lazy(() => import('./../Containers/Profile/Account/GovernmentID/Passport'));
const AddDone = lazy(() => import('./../Containers/Profile/Account/AddDone'));
const ChooseIdType = lazy(() => import('./../Containers/Profile/Account/ChooseIdType'));
const Listing = lazy(() => import('./../Containers/Profile/Listings/Listings'));
const Request = lazy(() => import('./../Containers/Profile/Listings/Requests'));
const Plans = lazy(() => import('./../Containers/Profile/Purchase/Plans'));
const Promote = lazy(() => import('./../Containers/Profile/Purchase/Promote'));
const Penalty = lazy(() => import('./../Containers/Profile/Purchase/Penalty'));
const TitleDeeds = lazy(() => import('./../Containers/Profile/Documents/TitleDeeds'));
const ProofOfFunds = lazy(() => import('./../Containers/Profile/Documents/ProofOfFunds'));
const ApprovalInPrinciple = lazy(() => import('./../Containers/Profile/Documents/ApprovalInPrinciple'));
const SellingAProperty = lazy(() => import('./../Containers/Profile/GetHelp/SellingAProperty'));
const BuyingAProperty = lazy(() => import('./../Containers/Profile/GetHelp/BuyingAProperty'));
const Password = lazy(() => import('./../Containers/Profile/Security/Password'));
const TwoFA = lazy(() => import('./../Containers/Profile/Security/TwoFA'));
const InviteFriends = lazy(() => import('./../Containers/Profile/Settings/InviteFriends'));
const ViaMail = lazy(() => import('./../Containers/Profile/Settings/ViaMail'));
const ViaNumber = lazy(() => import('./../Containers/Profile/Settings/ViaNumber'));
const Kucing = lazy(() => import('./../Containers/Profile/Settings/Kucing'));
const Legal = lazy(() => import('./../Containers/Profile/Settings/Legal'));
const Availableproperty = lazy(() => import('./../Containers/ListProperty/Availableproperty/Availableproperty'));
const AvalaibilityTime = lazy(() => import('./../Containers/ListPropertyStep2/Main/AvalaibilityTime'));
const DownloadApp = lazy(() => import('./../Containers/DownloadApp'));
const Privacy = lazy(() => import('./../Containers/Privacy'));
const Terms = lazy(() => import('./../Containers/Terms'));
/**
 * Routes definition
 */
const routes: RouteInterface[] = [
  {
    key: 'home',
    path: HOMEPAGE,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Home,
  },
  {
    key: 'heatMap',
    path: HEATMAP,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: HeatMap,
  },
  {
    key: 'priceMap',
    path: PRICEMAP,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Pricemap,
  },
  {
    key: 'seachbar',
    path: SEARCHBAR,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: SearchBar,
  },
  {
    key: 'guides',
    path: GUIDES,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Guide,
  },
  {
    key: 'bookings',
    path: BOOKINGS,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Bookings,
  },
  {
    key: 'track',
    path: TRACK,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Track,
  },
  {
    key: 'inbox',
    path: INBOX,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Inbox,
  },
  {
    key: 'listProperty',
    path: LISTPROPERTY,
    isExact: true,
    isPrivate: true,
    roles: [],
    component: ListProperty,
  },
  {
    key: 'propertyStep',
    path: PROPERTYSTEP,
    isExact: true,
    isPrivate: true,
    roles: [],
    component: PropertyStep,
  },

  {
    key: 'notfound',
    path: '/notfound',
    isExact: true,
    isPrivate: false,
    roles: [],
    component: NotFound,
  },
  {
    key: 'search',
    path: SEARCH,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Search,
  },
  {
    key: 'detailSell',
    path: DETAILSELL,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: DetailSell,
  },
  {
    key: 'detailBuy',
    path: DETAILBUY,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: DetailBuy,
  },
  {
    key: 'finish',
    path: FINISH,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Finish,
  },
  {
    key: 'modal',
    path: MODAL,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Modal,
  },
  {
    key: 'modalb',
    path: MODALBOOST,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Modalb,
  },
  {
    key: 'modalLast',
    path: MODALLAST,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: ModalLast,
  },
  {
    key: 'profile',
    path: PROFILE,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Profile,
  },
  {
    key: 'aboutMe',
    path: ABOUTME,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: AboutMe,
  },
  {
    key: 'governmentId',
    path: GOVERNMENTID,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: GovernmentID,
  },
  {
    key: 'nationalIdType',
    path: NATIONALIDTYPE,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: NationalID,
  },
  {
    key: 'singpass',
    path: SINGPASS,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Singpass,
  },
  {
    key: 'passport',
    path: PASSPORT,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Passport,
  },
  {
    key: 'addDone',
    path: ADDDONE,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: AddDone,
  },
  {
    key: 'chooseIdType',
    path: CHOOSEIDTYPE,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: ChooseIdType,
  },
  {
    key: 'listing',
    path: LISTING,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Listing,
  },
  {
    key: 'request',
    path: REQUEST,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Request,
  },
  {
    key: 'plans',
    path: PLANS,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Plans,
  },
  {
    key: 'promote',
    path: PROMOTE,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Promote,
  },
  {
    key: 'penalty',
    path: PENALTY,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Penalty,
  },
  {
    key: 'titleDeeds',
    path: TITLEDEEDS,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: TitleDeeds,
  },
  {
    key: 'proofOfFunds',
    path: PROOFOFFUNDS,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: ProofOfFunds,
  },
  {
    key: 'approvalInPrinciple',
    path: APPROVALINPRINCIPLE,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: ApprovalInPrinciple,
  },
  {
    key: 'sellingAProperty',
    path: SELLINGAPROPERTY,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: SellingAProperty,
  },
  {
    key: 'buyingAProperty',
    path: BUYINGAPROPERTY,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: BuyingAProperty,
  },
  {
    key: 'password',
    path: PASSWORD,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Password,
  },
  {
    key: 'twoFA',
    path: TWOFA,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: TwoFA,
  },
  {
    key: 'inviteFriends',
    path: INVITEFRIENDS,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: InviteFriends,
  },
  {
    key: 'viamail',
    path: VIAMAIL,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: ViaMail,
  },
  {
    key: 'vianumber',
    path: VIANUMBER,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: ViaNumber,
  },
  {
    key: 'kucing',
    path: KUCING,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Kucing,
  },
  {
    key: 'legal',
    path: LEGAL,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Legal,
  },
  {
    key: 'Availableproperty',
    path: AVAILABLE,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Availableproperty,
  },
  {
    key: 'AvalaibilityTime',
    path: AVAILAIBILITY,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: AvalaibilityTime,
  },
  {
    key: 'download',
    path: DOWNLOAD,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: DownloadApp,
  },
  {
    key: 'privacy',
    path: PRIVACY,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Privacy,
  },
  {
    key: 'terms',
    path: TERMS,
    isExact: true,
    isPrivate: false,
    roles: [],
    component: Terms,
  },
];

export default routes;
